<!-- Sky.Upload (jquery.upload.js) must be provided as a global dep -->
<template>
    <div>
        <!-- iframe to catch response of form submit (prevents redirect) -->
        <iframe :id="'upload-sink-'+fileuploadid" :name="'upload-sink-'+fileuploadid" src='' style='display: none'></iframe>
        <form :id="fileuploadid" method="post" action="" enctype="multipart/form-data" novalidate=""
              class="upload" :target="'upload-sink-'+fileuploadid">
            <input aria-hidden="true" @change="$emit('fileschanged')" type="file" :accept="fileExtensions" name="files" ref="uploadfiles" :id="'fileupload'+fileuploadid"
                   class="upload__file sr-only" data-multiple-caption="{count} files selected" :multiple="multiple">
            <input type="hidden" name="ajax" value="1">
            <div class="d-flex flex-column flex-center text-center" :class="{ 'pt-3': !inline, 'w-100': expanded }">
                <input type="button" @click="pickFile" class="btn btn--dark label-aligned m-auto" :class="{'w-100': expanded, 'w-auto@large': !expanded}" :disabled="uploadInProgress" :value="text"/>
            </div>
        </form>
    </div>
</template>

<script>

    export default {
        data() {
            return {fileupload:null, uploadInProgress: false}
        },
        props: {
          fileuploadid: {
            type: String
          },
          uploadFileExtensions: {
            type: Array,
            default: 0
          },
          multiple: {
            type: Boolean
          },
          inline: {
            type: Boolean,
            default: false
          },
          text: {
            type: String,
            default: `${window?.dict_prj.get("txtChoose")}`
          },
          expanded: {
            type: Boolean,
            default: false
          }
        },
        computed: {
            fileExtensions() {
                this.uploadFileExtensions.forEach( (extension, index, array) => array[index] = extension.startsWith( "." ) ? extension : "."+extension );
                return this.uploadFileExtensions.join(",")
            }
        },
        watch: {
          uploadInProgress: function() {
            this.$emit("fileUploadProgressStateChanged", this.uploadInProgress);
          }
        },
        methods: {
            pickFile: function() {
                this.$refs.uploadfiles.click();
            },
            emitUploadStarts: function( data ) {
                this.uploadInProgress = true;
                this.$emit("uploadStarts", data);
            },
            emitUpdateUploadState: function( data ) {
                this.$emit("updateUploadState", data);
            },
            emitUploadFinished: function( data ) {
                this.uploadInProgress = false;
                this.$emit("uploadFinished", data);
            },
            emitUploadError: function( data ) {
                this.uploadInProgress = false;
                this.$emit("uploadError", data);
            },
            init: function () {
                this.fileupload = new Sky.Upload(this.fileuploadid, this.uploadFileReceiverKey, {
                    "callbackOnStart": this.emitUploadStarts,
                    "callbackOnUploadRunning": this.emitUpdateUploadState,
                    "callbackOnUploadFinished": this.emitUploadFinished,
                    "callbackOnError": this.emitUploadError,
                    "webroot": webroot
                });
            },
            startUpload: function() {
                this.fileupload.start()
            },
            setFiles: function(files) {
                if( this.uploadInProgress )
                {
                    // do not allow interference while uploading
                    return;
                }
                this.$refs.uploadfiles.files = files;
                this.$emit("fileschanged")
            },
            getFiles: function() {
                return this.$refs.uploadfiles.files;
            }
        },
        mounted() {
            this.init();
        },
    }
</script>